module.exports = __webpack_public_path__ + "static/img/store-warn-active.c6fd529.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/store-warn-active.png
// module id = D+Hb
// module chunks = 58